import type { Optional } from '@festina-life/core'

import { useFetchPayableStopText } from '../../../hooks/useFetchPayableStopText'

type Props = {
  textId: Optional<string>
}

export const PayableStopText = ({ textId }: Props) =>
  useFetchPayableStopText(textId)
